import { shallowRef, ref, watch } from 'vue'
import { useTemplate } from '../../../hooks/index'
import { setValueByPath } from '../../../utils/index'
import { get } from '../../../utils/index'
import { useRoute, useRouter } from 'vue-router/composables'
import { useSetStorageComponent } from '../../criteria-form/hook/use-set-storage-component'
import { CRITERIFORMCOLUM } from '../../criteria-form/hook/use-common-param'
/**
 * 查询表单处理
 * @param {查询条件是否设置默认事件（如光标在输入框时点击回车触发查询等）} queryFormEvent
 * @returns
 */
export function useCriteriaQueryIframe(url, parametersStorageSuffix) {
  const { getTemplateData, compileData } = useTemplate()
  const queryForm = shallowRef({ item: [] })
  const queryData = ref({})

  const route = useRoute()
  const router = useRouter()

  const cacheType = ref('session')
  const clearFlag = ref(false)

  const {
    setParametersBySessionStorage,
    getParametersBySessionStorage,
    setParametersByLocalStorage,
    getParametersByLocalStorage,
  } = useSetStorageComponent(parametersStorageSuffix)

  watch(
    () => queryData.value,
    () => {
      if (cacheType.value == 'local') {
        if (!clearFlag.value) {
          // 如果clearFlag = true 说明是clear 清空的时候，就不用再去保存了
          setParametersByLocalStorage(queryData.value)
        } else {
          clearFlag.value = false
        }
      } else {
        setParametersBySessionStorage(queryData.value)
      }
    }
  )
  //当key存在时修改queryData对应key的值为data，key不存在时修改queryData为data

  const updateQueryData = (data, type) => {
    queryData.value = data
    clearFlag.value = type
  }

  //设置默认值
  const setDefaultQuery = (data) => {
    const templateData = getTemplateData()
    queryData.value = queryForm.value.items.reduce((pre, cur) => {
      if (cur.defaultValue) {
        setValueByPath(pre, cur.property, compileData(cur.defaultValue, templateData))
      }
      return pre
    }, {})
    queryData.value = Object.assign({}, queryData.value, data)
  }

  const setQueryForm = (resData) => {
    queryForm.value = {
      code: resData.code,
      id: resData.id,
      form: {
        property: {
          formGroup: false,
          colNum: CRITERIFORMCOLUM,
        },
      },
      items: resData.fields,
    }
  }

  const initParameter = async () => {
    const { defaultQueryId, defaultQueryParameters } = route.query ?? {}
    if (defaultQueryId) {
      router.replace({ name: route.name })
      return null
    } else if (defaultQueryParameters) {
      router.replace({ name: route.name })
      return defaultQueryParameters
    } else {
      if (cacheType.value == 'local') {
        return getParametersByLocalStorage()
      } else {
        return getParametersBySessionStorage()
      }
    }
  }

  const getCriteria = async () => {
    const [res] = await get(url)
    if (res) {
      cacheType.value = res?.data?.property?.cacheType || 'session'
      const defaultParameter = await initParameter()
      return [res.data, defaultParameter]
    } else {
      return Promise.reject({ msg: `【${url}】请求错误` })
    }
  }

  return {
    getCriteria,
    queryForm,
    queryData,
    updateQueryData,
    setQueryForm,
    setDefaultQuery,
    cacheType,
  }
}
